import { get, set, rm } from 'lockr';

import api from 'api';

enum Token {
  access_token = 'access_token',
  refresh_token = 'refresh_token',
  msal_access_token = 'msal_access_token',
  businessesId = 'businessesId',
  // legacy: the PersonsGUID was stored here and sent as the Oid header; never written now
  oid = 'oid',
  // not a credential: the session lives in an HttpOnly cookie the page can't read
  otpSession = 'otpSession',
  email = 'email',
  profileId = 'profileId',
  ssoFlag = 'ssoFlag',
}

const getToken = () => get(Token.msal_access_token);
const getRefreshToken = () => get(Token.refresh_token);

const login = (tokenResponse: any) => {
  set(Token.access_token, tokenResponse?.access_token);
  set(Token.refresh_token, tokenResponse?.refresh_token);
};

const setBusinessesId = (businessesId: number) => {
  set(Token.businessesId, businessesId);
};

const getBusinessesId = () => get(Token.businessesId);

const setProfileId = (profileId: number) => {
  set(Token.profileId, profileId);
  set(Token.ssoFlag, true);
};

const getProfileId = () => get(Token.profileId);

const removeProfileId = () => {
  rm(Token.profileId);
  rm(Token.ssoFlag);
};

const getSSOFlag = () => get(Token.ssoFlag);

const removeSSOFlag = () => {
  rm(Token.ssoFlag);
};

// a PersonsGUID left in storage by an older build is no longer a login; drop it
rm(Token.oid);

const hasOtpSession = () => get(Token.otpSession) === true;

// ends the OTP session server-side and clears its HttpOnly cookie; best effort, never shows the server-error modal
const endOtpSession = () => {
  if (hasOtpSession()) {
    api
      .post('Persons/Logout', undefined, { skipServerErrorModal: true })
      .catch(() => undefined);
  }

  rm(Token.otpSession);
};

const msalLogin = (tokenResponse: string) => {
  // a Microsoft sign-in after an OTP login must not leave the OTP session alive behind it
  endOtpSession();
  set(Token.msal_access_token, tokenResponse);
};

const setOtpSession = () => {
  rm(Token.msal_access_token);
  set(Token.otpSession, true);
};

const getUserEmail = () => get(Token.email);

const setUserEmail = (email: string) => {
  set(Token.email, email);
};

const removeUserEmail = () => rm(Token.email);

const deleteBusinessesId = () => {
  rm(Token.businessesId);
};

const logOut = () => {
  endOtpSession();
  rm(Token.access_token);
  rm(Token.refresh_token);
  rm(Token.msal_access_token);
  rm(Token.businessesId);
  rm(Token.oid);
  rm(Token.email);
};

export {
  getRefreshToken,
  login,
  logOut,
  getToken,
  msalLogin,
  setOtpSession,
  hasOtpSession,
  getUserEmail,
  setUserEmail,
  removeUserEmail,
  setBusinessesId,
  getBusinessesId,
  deleteBusinessesId,
  setProfileId,
  getProfileId,
  removeProfileId,
  getSSOFlag,
  removeSSOFlag,
};
